import React from 'react';
import { FaEdit } from 'react-icons/fa';
import * as Yup from 'yup';

import { ISize } from '../../../../../../models';

import {
  Container,
  Header,
  SizesList,
  SizeItem,
  EditSizesButton,
} from './styles';

type SizesProps = {
  sizes: ISize[];
};

export const SizesFormSchema = Yup.object().shape({});

const Sizes: React.FC<SizesProps> = ({ sizes }) => {
  return (
    <Container>
      <Header>
        <h2>Tamanhos</h2>
        <p>
          Veja aqui quais os tamanhos que seus produtos poderão ter, você pode
          editá-los acessando as configurações da loja
        </p>
      </Header>
      <SizesList>
        {sizes.map((size) => (
          <SizeItem key={size.id}>
            <h3>{size.name}</h3>
          </SizeItem>
        ))}
      </SizesList>
      <EditSizesButton to="/configuracoes/7/1">
        <FaEdit /> Editar tamanhos
      </EditSizesButton>
    </Container>
  );
};

export default Sizes;
